import React, {useEffect, useRef} from 'react';
import {Outlet, useLocation} from 'react-router-dom';
import UserParlaysContainer from "../../components/UserParlaysContainer/UserParlaysContainer";
import useDeviceType from "../../hooks/useDeviceType";
import {useDispatch, useSelector} from "react-redux";
import {selectActiveAndYesterdayUserParlays} from "../../stores/pickX/pickX.selectors";
import {ParlayType} from "../../constants/PickXEnums";
import {useParams} from "react-router-dom";
import pickXApi from "../../stores/pickX/pickX.api";
import {selectUserAccountId} from "../../stores/account/account.selectors";
import './LobbyView.style.scss';
import {ModalType} from "../../components/AppModal/ModalTypes";
import OnBoardingPopUp from "../PopUps/OnBoardingPopUp/OnBoardingPopUp";
import useAppModalService from "../../hooks/useAppModalService";
const LobbyView = (props) => {
    const dispatch = useDispatch();
    const {isDesktop} = useDeviceType();
    const userParlays = useSelector(selectActiveAndYesterdayUserParlays);
    const accountId = useSelector(selectUserAccountId);
    const currentAccountId = useRef(accountId);
    const location = useLocation();
    const preSelectedParlayId = useParams().parlayId;
    const isLobby = location.pathname.toLowerCase() === "/lobby";
    const isPicks = location.pathname.toLowerCase().includes("/lobby/picks/");
    const isCreateYourOwn = location.pathname.toLowerCase().includes("/lobby/createyourown");

    const initParlays = (forceRefetch = false) => {
        dispatch(pickXApi.endpoints.getActiveUserParlays.initiate(undefined, { forceRefetch }));
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        initParlays();
    }, []);

    useEffect(() => {
        if (accountId > 0 && currentAccountId.current !== accountId) {
            currentAccountId.current = accountId;
            initParlays(true);
        }
    }, [accountId]);

    let parlays = userParlays;
    if (isLobby)
        parlays = parlays.filter(p => !p.Id.includes('new'));
    else if (isPicks)
        parlays = parlays.filter(p => !p.Id.includes('new') || (p.parlayType === ParlayType.CreateFromPreSelected && p.preSelectedParlayId === preSelectedParlayId ) );
    else if (isCreateYourOwn)
        parlays = parlays.filter(p => !p.Id.includes('new') || p.parlayType === ParlayType.CreateYourOwn);

    return <div className={"LobbyView"}>
                <div className={"lobbyContainer"}>
                    <Outlet/>
                    {isDesktop && <UserParlaysContainer userParlays={parlays} />}
                </div>
            </div>
}

export default LobbyView;